import React, { Component } from 'react'
import "../css/email-subscribe.css"

import { EMAIL_SUBSCRIBE_STATUS } from "../containers/account-setting-container";


class EmailSubscribe extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className='upper-section-container'>
                <div className='upper-section-title upper-section-subtitle'>
                    Email Notifications
                <div className={`toggle-background ${this.props.emailSubscribeToggleable ? '' : 'toggle-disable'}`}
                        onClick={this.props.toggleEmailSubscribe}>
                        <div
                            className={this.props.currentStatus === EMAIL_SUBSCRIBE_STATUS.ON ? 'toggle-content toggle-content-active' : 'toggle-content'}>On
                    </div>
                        <div
                            className={this.props.currentStatus === EMAIL_SUBSCRIBE_STATUS.OFF ? 'toggle-content toggle-content-active' : 'toggle-content'}>Off
                    </div>
                    </div>
                </div>
                <div className='upper-section-introduce'>
                    Enable this feature to receieve email notifications when prints are completed, or cancelled.
                </div>
            </div>
        );
    }
}

export default EmailSubscribe


// WEBPACK FOOTER //
// ./src/containers/email-subscribe.js